import React from 'react'

const EspaciadorVertical = (props) => {
    const { height = 20 } = props.styles;

    return (
        <div style={{ height }} />
    )
}

export default EspaciadorVertical